const toId = (maybeObj) => (typeof maybeObj === "object" && maybeObj ? maybeObj.id : maybeObj);
const pad2 = (value) => String(value).padStart(2, "0");
const toApiDateTime = (value) => {
  if (value == null || value === "") return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = pad2(value.getMonth() + 1);
    const day = pad2(value.getDate());
    return `${year}-${month}-${day}T00:00:00`;
  }
  const stringValue = String(value).trim();
  const displayDateMatch = stringValue.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (displayDateMatch) {
    const [, day, month, year] = displayDateMatch;
    return `${year}-${pad2(month)}-${pad2(day)}T00:00:00`;
  }
  return value;
};

// ---------- OUTBOUND (UI -> API DTO) ----------
export const toEmployeeCoreDTO = (model) => ({
  companyId: model.companyId,
  hash: model.hash,
  sex: toId(model.sex),
  yearOfBirth: model.yearOfBirth,
});

export const toEmployeePayrollDTO = (model, companyInputId) => ({
  employeeId: model.employeeId,
  companyInputId,
  grossSalary: model.grossSalary,
  addBenefits: model.addBenefits,
  baseSalary: model.baseSalary,
  remarks: model.remarks || "",
  employmentStatusId: toId(model.employmentStatus),
  employmentLevelId: toId(model.employmentLevel),
  specXFuncId: toId(model.specXFunc),
});

export const toEmployeeDetailsDTO = (model, companyInputId) => ({
  employeeId: model.employeeId,
  companyInputId,
  employmentGrade: model.employmentGrade,
  emplEndDate: toApiDateTime(model.emplEndDate),
  emplStartDate: toApiDateTime(model.emplStartDate),
  employmentType: toId(model.employmentType),
  yearlyNominalTime: model.yearlyNominalTime,
});

export const toEmployeeAttendanceDTO = (model, companyInputId) => ({
  employeeId: model.employeeId,
  companyInputId,
  yearlyPresenceTime: model.yearlyPresenceTime,
});

export const toEmployeeNonOrderRelatedTimeDTO = (model, companyInputId) => ({
  employeeId: model.employeeId,
  companyInputId,
  others: model.others,
  edvOperation: model.edvOperation,
  managementLeadership: model.managementLeadership,
  contest: model.contest,
  advertisingAcquisition: model.advertisingAcquisition,
  educationTraining: model.educationTraining,
});

// ---------- INBOUND (API DTO -> UI) ----------
export const fromEmployeeCoreDTO = (dto) => ({ employeeId: dto.id });
export const fromEmployeePayrollDTO = (dto) => ({ employeePayrollId: dto.id });
export const fromEmployeeDetailsDTO = (dto) => ({ employeeEmplDetailId: dto.id });
export const fromEmployeeAttendanceDTO = (dto) => ({ employeeAttendanceTimeId: dto.id });
export const fromEmployeeNonOrderRelatedTimeDTO = (dto) => ({ employeeNonOrderRelatedAttTimeId: dto.id });
